import { Badge } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'


export default forwardRef((p: Props) => {
	if (!p.label) return null
	const LeftIcon = p.leftIcon && p.leftIcon in R.libs.icons
		? R.libs.icons[p.leftIcon as keyof typeof R.libs.icons]
		: null
	const RightIcon = p.rightIcon && p.rightIcon in R.libs.icons
		? R.libs.icons[p.rightIcon as keyof typeof R.libs.icons]
		: null
	return (
		<Badge
			leftSection={LeftIcon ? <LeftIcon size={12} /> : undefined}
			rightSection={RightIcon ? <RightIcon size={12} /> : undefined}
			{...p} {...p.customProps}
		>
			{p.label}
		</Badge>
	)
})
